"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const slider = [
  { index: 1, image: "/images/farmers1.webp" },
  { index: 2, image: "/images/markeets.jpeg" },
  { index: 3, image: "/images/farming.jpeg" },
  { index: 4, image: "/images/fertilisers.jpg" },
  { index: 5, image: "/images/markets.jpeg" },
];

export default function ChooseUs() {
  return (
    <div className="flex items-center justify-center w-full h-[400px] sm:h-[500px] lg:h-[600px] px-4 sm:px-6 lg:px-8">
      <div className="relative w-full h-full max-w-7xl">
        <style>{`
          .custom-swiper .swiper-button-next,
          .custom-swiper .swiper-button-prev {
            color: white;
            background: rgba(0, 0, 0, 0.5);
            width: 44px;
            height: 44px;
            border-radius: 50%;
            transition: all 0.3s ease;
          }
          
          .custom-swiper .swiper-button-next:hover,
          .custom-swiper .swiper-button-prev:hover {
            background: rgba(0, 0, 0, 0.8);
            transform: scale(1.1);
          }
          
          .custom-swiper .swiper-button-next:after,
          .custom-swiper .swiper-button-prev:after {
            font-size: 20px;
            font-weight: bold;
          }
          
          .custom-swiper .swiper-slide {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          @media (max-width: 640px) {
            .custom-swiper .swiper-button-next,
            .custom-swiper .swiper-button-prev {
              width: 36px;
              height: 36px;
            }
            
            .custom-swiper .swiper-button-next:after,
            .custom-swiper .swiper-button-prev:after {
              font-size: 16px;
            }
          }
        `}</style>
        
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation={true}
          loop={true}
          centeredSlides={true}
          slidesPerView={1}
          spaceBetween={20}
          allowTouchMove={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          className="custom-swiper w-full h-full"
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
              allowTouchMove: true,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
              allowTouchMove: true,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 40,
              allowTouchMove: false,
            },
          }}
        >
          {slider.map((slide) => (
            <SwiperSlide key={slide.index}>
              <div
                className="w-full h-full rounded-xl sm:rounded-2xl bg-cover bg-center shadow-lg transition-transform duration-300 hover:scale-105 cursor-pointer"
                style={{ 
                  backgroundImage: `url(${slide.image})`,
                  minHeight: '300px'
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}